import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {};

const CRAWL_TYPE = 'media_center_grid';
export default {
  crawlType: CRAWL_TYPE,
  matchTemplates: [
    {
      type: sectionType.sectionSatelliteGrid,
      tags: [],
      priority: 1,
    },
  ],
};
